import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  category: {
    font: {
      size: '1.2rem',
      lineHeight: '2rem',
    },
    marginTop: '0.4rem',
    paddingBottom: '0.8rem',
    textAlign: 'left',
    color: colors.neutral[700],
    textTransform: 'uppercase',
    borderBottom: '0.1rem solid #C1C7CD',
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    paddingTop: '0.8rem',
    margin: '0 -1.2rem',
  },
  halfInputLayout: {
    width: 'calc(50% - 2.4rem)',
    padding: '0 1.2rem 3.6rem 1.2rem',
  },
  fullInputLayout: {
    width: 'calc(100% - 2.4rem)',
    padding: '0 1.2rem 3.6rem 1.2rem',
  },
};

const createStyles = createUseStyles(styles);

export { styles, createStyles };
